"use client"

import { BarChart3, TrendingUp, ShoppingCart, FileText, Send, Bell, LogOut, LayoutDashboard, ChevronRight } from "lucide-react"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Button } from "@/components/ui/button"
import { usePathname } from "next/navigation"

export function Sidebar({ currentPage }: { currentPage?: string }) {
  const pathname = usePathname()
  const isDashboard = pathname === "/"
  const isWealthRotation = pathname.includes("wealth-rotation")

  return (
    <aside className="w-64 bg-card border-r border-border p-6 flex flex-col">
      <div className="flex items-center gap-2 mb-8">
        <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
          <span className="text-primary-foreground font-bold text-lg">M</span>
        </div>
        <div className="flex flex-col">
          <span className="font-bold text-foreground">MyRite</span>
          <span className="text-xs text-muted-foreground">WALLET</span>
        </div>
      </div>

      <nav className="space-y-2 flex-1">
        <a
          href="/"
          className={`w-full justify-start gap-3 rounded-full flex items-center px-4 py-2 transition-colors ${
            isDashboard
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:text-foreground hover:bg-muted"
          }`}
        >
          <LayoutDashboard className="w-5 h-5" />
          <span>Dashboard</span>
        </a>

        <div className="space-y-1">
          <a
            href="/wealth-rotation"
            className={`w-full justify-start gap-3 flex items-center px-4 py-2 transition-colors rounded-lg ${
              isWealthRotation
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:text-foreground hover:bg-muted"
            }`}
          >
            <TrendingUp className="w-5 h-5" />
            <span>Wealth Rotation</span>
          </a>
        </div>

        <div className="space-y-1">
          <a
            href="/save-cave"
            className={`w-full justify-start gap-3 flex items-center px-4 py-2 transition-colors rounded-lg ${
              pathname.includes("save-cave")
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:text-foreground hover:bg-muted"
            }`}
          >
            <ShoppingCart className="w-5 h-5" />
            <span>SaveCave</span>
          </a>
        </div>

        {/* <div className="space-y-1">
          <Button variant="ghost" className="w-full justify-start gap-3 text-muted-foreground hover:text-foreground">
            <ShoppingCart className="w-5 h-5" />
            <span>Savings Rotation</span>
          </Button>
        </div> */}

        <Button variant="ghost" className="w-full justify-start gap-3 text-muted-foreground hover:text-foreground">
          <FileText className="w-5 h-5" />
          <span>View Wallets</span>
        </Button>

        <Button variant="ghost" className="w-full justify-start gap-3 text-muted-foreground hover:text-foreground">
          <BarChart3 className="w-5 h-5" />
          <span>Payment Approvals</span>
        </Button>

        <Button variant="ghost" className="w-full justify-start gap-3 text-muted-foreground hover:text-foreground">
          <Send className="w-5 h-5" />
          <span>Send Messages</span>
        </Button>

        <Button variant="ghost" className="w-full justify-start gap-3 text-muted-foreground hover:text-foreground">
          <Bell className="w-5 h-5" />
          <span>Notifications</span>
        </Button>

        {/* Added Reports link to sidebar navigation */}
        <div className="space-y-1">
          <a
            href="/reports"
            className={`w-full justify-start gap-3 flex items-center px-4 py-2 transition-colors rounded-lg ${
              pathname.includes("reports")
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:text-foreground hover:bg-muted"
            }`}
          >
            <FileText className="w-5 h-5" />
            <span>Reports</span>
          </a>
        </div>

        
      </nav>

      <Button variant="ghost" className="w-full justify-start gap-3 text-muted-foreground hover:text-foreground">
        <LogOut className="w-5 h-5" />
        <span>Sign Out</span>
      </Button>
    </aside>
  )
}
